<script setup>
import TheFooter from '@/components/Layout/Components/TheFooter.vue';
import TheForm from '@/components/Layout/Components/TheForm.vue';
import TheHeader from '@/components/Layout/Components/TheHeader.vue';
import TheDevBar from '@/components/TheDevBar.vue';
import ErrorMessage from '@/components/Views/Funnels/shared/all-funnels/components/ErrorMessage.vue';
import { formStore } from '@/stores/form.js';

const form = formStore();
</script>

<template>
  <div class="wrapper">
    <BaseSpinner v-if="form.baseSpinner" />
    <BaseLoader v-if="form.baseLoader" />
    <TheDevBar v-if="form.getFunnelVersion === 'dev-local' || form.devMode" />
    <TheHeader />
    <main>
      <div class="container-lg">
        <div class="row">
          <div class="col-12 col-lg-7 col-xxl-8">
            <!-- The app form -->
            <TheForm :key="form.stepKey">
              <ErrorMessage v-if="form.error" />

              <slot />
            </TheForm>
          </div>
        </div>
      </div>
    </main>
    <!-- The footer -->
    <TheFooter />
  </div>
</template>
